<div class="offcanvas-header" #header>
    <h5 class="offcanvas-title">Wolseley Stock Check</h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="offcanvas-body overflow-auto" style="max-height: 90vh">
    <sf-wolseley-stock-check [products]="productCodes" [showEditFavourites]="true" (onNavigate)="close()" />
    <hr />
    <div class="d-grid gap-2">
        <button sfButton type="button" color="danger" size="lg" (click)="close()">Close</button>
    </div>
</div>
